import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=5b3e240d&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./registerDialog.vue?vue&type=style&index=0&id=5b3e240d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e240d",
  null
  
)

export default component.exports